import { render, staticRenderFns } from "./dr-settings-layout-component.vue?vue&type=template&id=7ad20e40&"
import script from "./dr-settings-layout-component.vue?vue&type=script&lang=js&"
export * from "./dr-settings-layout-component.vue?vue&type=script&lang=js&"
import style0 from "./dr-settings-layout-component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports